const freon = "c2lsdmVyIEdBVkUgb3V0c2lkZSBERUxJR0hUIGFybXMgQ0FUVExFIDIx";

export default freon;
